import { useEffect, useState } from 'react'
import type { BrokerSession } from '@/api/admin'
import { listBrokerSessions } from '@/api/admin'
import SessionRow from './SessionRow'

export default function SessionsList() {
  const [sessions, setSessions] = useState<BrokerSession[]>([])
  const [includeRevoked, setIncludeRevoked] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const load = async () => {
    setLoading(true)
    setError(null)
    try {
      const data = await listBrokerSessions(includeRevoked)
      setSessions(data.sessions)
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e))
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => { load() }, [includeRevoked])

  return (
    <div data-testid="sessions-page">
      <h1>Sessões do Broker ZTNA</h1>
      <label>
        <input
          type="checkbox"
          checked={includeRevoked}
          onChange={e => setIncludeRevoked(e.target.checked)}
        /> incluir revogadas
      </label>
      {error && <div role="alert">Erro: {error}</div>}
      {loading && <div>carregando...</div>}
      <table>
        <thead>
          <tr>
            <th>Email</th><th>IP</th><th>Iniciada</th>
            <th>Última atividade</th><th>Status</th><th></th>
          </tr>
        </thead>
        <tbody>
          {sessions.map(s => (
            <SessionRow key={s.session_id} session={s} onRevoked={load} />
          ))}
        </tbody>
      </table>
    </div>
  )
}
